import Modal from "react-bootstrap/Modal";
import "./modal.css";

export default Modal;
